<div
  class="position-absolute history z-1 translate-middle-x start-50 bg-dark border border-darkgray rounded-2"
>
  <div class="position-relative d-flex align-items-center gap-3 p-3">
    <app-datetime-picker
      [date]="currentDate?.toISOString()"
      (datetimeChanged)="handleOnTimestampChanged($event)"
      [disabled]="isLoading()"
    >
    </app-datetime-picker>

    <div
      data-cy="historic-view-reload-button"
      class="d-flex position-relative align-self-stretch align-items-center btn btn-darkgray"
      (click)="handleReloadClick()"
    >
      <span class="fs-sm" [class.text-darkgray]="isLoading()">Reload</span>
      <div class="position-absolute translate-middle start-50 top-50">
        <div
          class="spinner-border text-white spinner-border-sm"
          [class.d-none]="!isLoading()"
          role="status"
        ></div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showReloadStatuses && nonReloadableStatuses.length > 0"
    class="border-top border-darkgray px-3 py-2"
  >
    <div class="d-flex align-items-center justify-content-center mb-2">
      <span class="text-gray fs-sm"
        >{{ getNonReloadableCount() }} selected layer(s) could not reload</span
      >
    </div>

    <div class="d-flex flex-column gap-1">
      <div
        *ngFor="let status of nonReloadableStatuses"
        class="d-flex align-items-center rounded border border-darkgray px-2 py-1"
      >
        <div class="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
          <span
            class="rb-ic fs-md"
            [class.rb-ic-alert-info]="!status.canReload"
            [class.text-warning]="!status.canReload"
          ></span>
          <span class="text-body fs-sm text-truncate">{{ status.label }}</span>
        </div>
        <div class="d-flex justify-content-end text-end ms-2" style="min-width: 120px">
          <span class="text-gray fs-sm text-nowrap">Needs zoom {{ status.minZoom }}+</span>
        </div>
      </div>
    </div>
  </div>
</div>
